import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { IConfig, DocumentEditorModule, DocumentEditorComponent } from '@onlyoffice/document-editor-angular';
import { IUser } from '../../../@core/models/model';
import { environment } from '../../../../environments/environment.dev';
import { ONLY_OFFICE_EDITOR_TYPE } from '../../../@core/models/enums';


interface Position {
  paragraph: number;
  offset: number;
}

interface Range {
  startPos: Position;
  endPos: Position;
}

declare global {
  var Asc: any;
}
declare var Api: any;


@Component({
  selector: 'app-only-office-doc-editor',
  imports: [DocumentEditorModule],
  standalone: true,
  templateUrl: './only-office-doc-editor.component.html',
  styleUrl: './only-office-doc-editor.component.scss'
})
export class OnlyOfficeDocEditorComponent implements OnInit, OnDestroy {

  @ViewChild('docEditor') docEditorRef!: DocumentEditorComponent;
  @Input() contractId: string = '';
  @Input() user !: IUser;
  @Input() editorId: string = 'docxEditor';
  @Output() documentReady = new EventEmitter<void>();

  config!: IConfig;
  connector: any;
  showEditor = false;

  @Input()
  set configData(config: IConfig) {
    this.showEditor = false;
    this.config = config;
    setTimeout(() => {
      this.showEditor = true;
    });
  }
  public onlyOfficeServer = environment.onlyOfficeServer;
  private docEditor: any;
  private docsAPI: any;

  constructor() { }

  ngOnInit(): void {

  }

  comments: any[] = [];

  onDocumentReady = () => {
    this.documentReady.emit();
    this.docsAPI = (window as any).DocsAPI;
    this.docEditor = (window as any).DocEditor;
    if (this.config.documentType == ONLY_OFFICE_EDITOR_TYPE.WORD) {
      this.connector = this.docEditor.instances[this.editorId]?.createConnector();
    }
  }


  onDocumentStateChange = (event: any) => {
  }

  insertTextAtCursor(text: string) {
    if (!this.connector) return;
    // Use Asc.scope to pass data into the sandboxed command function
    Asc.scope.textToInsert = text;
    this.connector.callCommand(() => {
      const oDocument = Api.GetDocument();
      const oParagraph = Api.CreateParagraph();
      oParagraph.AddText(Asc.scope.textToInsert);
      oDocument.InsertContent([oParagraph]);
    }, () => {
      console.log("Inserted text at cursor");
    });
  }

  onLoadComponentError = (errorCode: any, errorDescription: any) => {
    switch (errorCode) {
      case -1: // Unknown error loading component
        console.error(errorDescription)
        break
      case -2: // Error load DocsAPI from http://documentserver/
        console.error(errorDescription)
        break
      case -3: // DocsAPI is not defined
        console.error(errorDescription)
        break
    }
  }




  ngOnDestroy(): void {
    if (this.connector && this.connector?.destroy) {
      try {
        this.connector.destroy();
      } catch (error) {
        console.error('Error destroying connector:', error);
      }
    }
    const docEditor = (window as any).DocEditor;
    if (docEditor && docEditor.instances && docEditor.instances[this.editorId]) {
      try {
        docEditor.instances[this.editorId].destroyEditor();
      } catch (error) {
        console.error('Error destroying editor instance:', error);
      }
    }
  }

}
